module.exports = __webpack_public_path__ + "static/media/klassische-massage-mobile.cd924b81.jpg";